export const INITIAL_STEPS = [
  "Service Selection",
  "Vehicle Selection",
  "Details",
  "Select Add-Ons",
  "Contact Information",
  "Billing Information",
];

export const FLIGHT_STEPS = [
  "Service Selection",
  "Vehicle Selection",
  "Flight Details",
  "Select Add-Ons",
  "Contact Information",
  "Billing Information",
];

export const BOOKING_STEPS = [
  "Service Selection",
  "Vehicle Selection",
  "Booking Details",
  "Select Add-Ons",
  "Contact Information",
  "Billing Information",
];

export const CUSTOM_LOCATION_STEPS = ["Transportation Quote"];

export const SHUTTLE_STEPS = [
  "Service Selection",
  "Vehicle Selection",
  "Flight Details",
  "Contact Information",
  "Billing Information",
];
